import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ClientMode from '../ClientMode/ClientMode';
import AdvisorMode from '../AdvisorMode/AdvisorMode';

class App extends PureComponent {

  render() {
    return (
      <div>
      {this.props.mode === 'client' && this.props.clientID &&
        <ClientMode />
      }
      {this.props.mode === 'advisor' && this.props.token &&
        <AdvisorMode />
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mode: state.params.mode,
    clientID: state.params.clientID,
    token: state.params.token,
  };
}

export default connect(mapStateToProps)(App);




// WEBPACK FOOTER //
// ./src/components/App/App.js